import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleManager from "../../../../framework/core/module_manager";
import EventManager from "../../../../manager/event_manager";
import ChatRecordItem from "./chatrecorditem"
import ChatRecordData from "./chatrecorddata";
import TableChatData from "./tablechat_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class TableChatView extends ViewBase {

    @property(cc.Button)
    btnClose: cc.Button = null;
    @property(cc.Node)
    FrameBg: cc.Node = null;
    @property(cc.Button)
    btnSend: cc.Button = null;
    @property(cc.EditBox)
    editBox: (cc.EditBox) = null;
    @property(cc.Node)
    ContentList: cc.Node[] = [];

    @property(cc.Node)
    itemparent0: cc.Node = null
    @property(cc.Node)
    itemparent1: cc.Node = null
    @property(cc.Node)
    itemparent2: cc.Node = null
    @property(cc.ScrollView)
    historyScrollView: cc.ScrollView = null
    @property(cc.Node)
    itemprefab2: cc.Node = null
    @property(cc.Node)
    InputRoot: cc.Node = null
    @property(cc.Node)
    TabButtonList: cc.Node[] = []
    itemprefab2Hight: number = 90
    _targeY = 0
    ChatRecordItemArr: ChatRecordItem[] = [];

    onInit() {
        this.itemprefab2.active = false
    }

    onShow() {
        this.itemprefab2.active = false
    }


    IsInitContent = false
    InitContent() {
        if (!this.IsInitContent) {
            for (const key in TableChatData.ChatTextList) {
                if (TableChatData.ChatTextList.hasOwnProperty(key)) {
                    const value = TableChatData.ChatTextList[key]
                    let item: cc.Node = this.itemparent1.children[Number(key) - 1]
                    item.active = true
                    item.scale = 1
                    item.name = key
                    let Label = item.getChildByName("Label").getComponent(cc.Label)
                    Label.string = value
                    item.on("click", this.onClick_Content1, this)
                }
            }
            this.IsInitContent = true
        }
    }

    private onClick_Content1(event: cc.Button) {
        let node: cc.Node = event.node
        EventManager.instance.dispatch("tablechat_sendcontent", 0, node.name)
        ModuleManager.instance.hideModule("TableChat")
    }

    RefreshChatRecord(DataArr: ChatRecordData[]) {
        this.showRecordPanel(DataArr)
    }

    getCardNode(index: number, prefab: cc.Node, parent: cc.Node): cc.Node {
        if (parent.childrenCount <= index) {
            var node = cc.instantiate(prefab)
            node.position = cc.v2(0, 0)
            node.scale = 1
            node.parent = parent
            node.active = false
            return this.getCardNode(index, prefab, parent)
        }
        else {
            return parent.children[index]
        }
    }

    showRecordPanel(datas: ChatRecordData[]) {
        let length = datas.length
        for (let i = 0; i < length; i++) {
            let item = this.getCardNode(i, this.itemprefab2, this.itemparent2)
            let recordItem = item.getComponent(ChatRecordItem)
            let data = datas[i]
            recordItem.setData(data)
        }

        if (this.itemparent2.childrenCount > length) {
            for (let i = length; i < this.itemparent2.childrenCount; i++) {
                this.itemparent2.children[i].active = false
            }
        }
        this.itemScroll()
    }

    itemScroll() {
        let activeCount = this.getActiveChildCount(this.itemparent2)
        if (activeCount > 6) {//超过一屏显示
            this.historyScrollView.scrollToBottom(0.1)
        } else {
            this.historyScrollView.scrollToTop()
        }
    }

    private getActiveChildCount(parent: cc.Node) {
        let count = 0
        let length = parent.childrenCount
        for (let i = 0; i < length; i++) {
            if (parent.children[i].active) {
                count++
            }
        }
        return count
    }
}